import { required } from "ra-core";
import { BooleanInput } from "@/components/admin/boolean-input";
import { DateTimeInput } from "@/components/admin/date-time-input";
import { ReferenceInput } from "@/components/admin/reference-input";
import { SelectInput } from "@/components/admin/select-input";
import { TextInput } from "@/components/admin/text-input";
import { AutocompleteInput } from "@/components/admin/autocomplete-input";

import { activityPriorities, activityTypes } from "./activityModel";

export const ActivityInputs = () => (
  <div className="flex flex-col gap-4">
    <div className="flex gap-4 flex-col md:flex-row">
      <SelectInput
        source="type"
        choices={activityTypes}
        defaultValue="follow_up_call"
        validate={required()}
        helperText={false}
        className="flex-1"
      />
      <SelectInput
        source="priority"
        choices={activityPriorities}
        defaultValue="normal"
        helperText={false}
        className="flex-1"
      />
    </div>
    <TextInput source="title" validate={required()} helperText={false} />
    <div className="flex gap-4 flex-col md:flex-row">
      <DateTimeInput
        source="starts_at"
        validate={required()}
        helperText={false}
        className="flex-1"
      />
      <DateTimeInput source="ends_at" helperText={false} className="flex-1" />
    </div>
    <BooleanInput source="all_day" helperText={false} />
    <ReferenceInput source="prospect_id" reference="prospects" perPage={20}>
      <AutocompleteInput
        label="resources.activities.fields.prospect_id"
        optionText="owner_name"
        helperText={false}
      />
    </ReferenceInput>
    <TextInput source="description" multiline helperText={false} />
    <TextInput source="action_plan" multiline helperText={false} />
  </div>
);
